import React from 'react';
import { RxChevronRight } from 'react-icons/rx';

import styled from 'styled-components';

import usePageNavigate from 'hooks/common/usePageNavigate';
import useNavigation from 'hooks/menu/useNavigation';

/**
 * 페이지 이동을 위한 네비게이션 컴포넌트
 * @returns {JSX.Element}
 */
const Navigation = () => {
  const { location, onNavClick } = usePageNavigate();
  const { navigation } = useNavigation();

  if (!navigation) return <></>;
  return (
    <NavigationWrap>
      <NavigationInner>
        <NavigationList>
          {navigation.map((el, idx) => {
            const isPath = el.path && el.path !== location.pathname;
            return (
              <li className="nav_item" key={idx}>
                {/* 첫번째 또는 마지막 항목이 아닌 경우 화살표 아이콘을 렌더링 */}
                {idx !== 0 && navigation.length !== idx && <RxChevronRight />}
                {/* navigation 항목의 제목을 렌더링 */}
                <Item
                  $path={String(isPath)}
                  onClick={() => isPath && onNavClick(el.path)}
                >
                  {el.title}
                </Item>
              </li>
            );
          })}
        </NavigationList>
      </NavigationInner>
    </NavigationWrap>
  );
};

export default Navigation;

const NavigationWrap = styled.div`
  display: flex;
  max-width: 1440px;
  width: 100%;
`;
const NavigationInner = styled.div`
  width: 100%;
  max-width: 1440px;
  /* padding: 16px 0 0 40px; */
  padding: 16px 0 0 32px;

  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
`;
const NavigationList = styled.ul`
  display: flex;
  align-items: center;
  height: 40px;

  .nav_item {
    display: flex;
    align-items: center;
    font-size: 14px;

    &.cursor {
      cursor: pointer;
    }

    svg {
      margin: 0px 8px;
    }
  }
`;

const Item = styled.span`
  cursor: ${({ $path }) => ($path === 'true' ? 'pointer' : 'auto')};
`;
